export default {
  en: {
    /* ----- Data Loss Prevention ----- */
    // FileTransfers.vue
    fileTransfers: "File Transfers",
    back: "Back",
    change: "Change",
    date: "Date:",
    cancel: "Cancel",
    ok: "OK",
    workSchedule: "Work Schedule:",
    timezone: "Timezone:",
    team: "Team:",
    all: "All",
    changeEmployee: "Change Employee",
    select: "Select",
    somethingWentWrongLoadingFileTransfers:
      "Something went wrong while loading your file transfers data. Please try after some time.",
    noEmployeesToList: "There are no employees to list",
    noDataAvailable: "No data available",
    noEmpData: "No Emp Data",
    eId: "E-ID:",

    // FileTransferSummaryChart.vue
    access: "Access",
    copy: "Copy",
    create: "Create",
    delete: "Delete",
    download: "Download",
    rename: "Rename",
    upload: "Upload",
    write: "Write",
    numberOfFiles: "Number of files",
    time24HoursFormat: "Time (24 hours format)",
    noFileOperationalActivitiesReportedUnderCategory:
      "No file operational activities reported under this category",
    noFileOperationalActivitiesReported:
      "No file operational activities reported",
    technicalDifficulties:
      "It's us! There seems to be some technical difficulties. Please try after some time.",
    somethingWentWrongFetchingTeamFileTransferChart:
      "Something went wrong while fetching your team file transfer chart details. If you continue to see this issue please contact system admin.",
    somethingWentWrongFetchingTeamFileTransferChartTryLater:
      "Something went wrong while fetching your team file transfer chart details. Please try after some time.",

    // ListIndividualFileActions.vue
    retry: "Retry",
    time: "Time",
    action: "Action",
    source: "Source",
    folder: "Folder",
    fileName: "File Name",
    domain: "Domain",
    fileExtension: "File Extension",
    noFileOperationalActivitiesFound:
      "There are no file operational activities found",
    noMatchingSearchResultsFound: "No matching search results found.",
    tryAgainByChangingFilters:
      "Please try again by changing the filters or clear it to get all data.",
    technicalDifficultiesWithErrorCode:
      "It's us! There seems to be some technical difficulties. Please try after some time - ",
    somethingWentWrongFetchingFileTransferDetails:
      "Something went wrong while fetching your the file transfer details. If you continue to see this issue please contact system admin - ",
    somethingWentWrongFetchingTeamTransferDetails:
      "Something went wrong while fetching your team the transfer details. Please try after some time",

    // ListFileTransfers.vue
    employees: "Employees",
    somethingWentWrongFetchingTeamFileTransferDetails:
      "Something went wrong while fetching your team file transfer details. If you continue to see this issue please contact system admin - ",
    somethingWentWrongFetchingTeamFileTransferDetailsTryLater:
      "Something went wrong while fetching your team file transfer details. Please try after some time.",
    searchPlaceholder: "Search",
  },
  sp: {
    /* ----- Data Loss Prevention ----- */
    // FileTransfers.vue
    fileTransfers: "Transferencias de Archivos",
    back: "Atrás",
    change: "Cambiar",
    date: "Fecha:",
    cancel: "Cancelar",
    ok: "Aceptar",
    workSchedule: "Horario de Trabajo:",
    timezone: "Zona Horaria:",
    team: "Equipo:",
    all: "Todos",
    changeEmployee: "Cambiar Empleado",
    select: "Seleccionar",
    somethingWentWrongLoadingFileTransfers:
      "Algo salió mal al cargar los datos de transferencias de archivos. Por favor, inténtelo después de un tiempo.",
    noEmployeesToList: "No hay empleados para listar",
    noDataAvailable: "No hay datos disponibles",
    noEmpData: "Sin Datos de Empleado",
    eId: "ID-E:",

    // FileTransferSummaryChart.vue
    access: "Acceso",
    copy: "Copiar",
    create: "Crear",
    delete: "Eliminar",
    download: "Descargar",
    rename: "Renombrar",
    upload: "Subir",
    write: "Escribir",
    numberOfFiles: "Número de archivos",
    time24HoursFormat: "Hora (formato 24 horas)",
    noFileOperationalActivitiesReportedUnderCategory:
      "No se reportaron actividades operativas de archivos en esta categoría",
    noFileOperationalActivitiesReported:
      "No se reportaron actividades operativas de archivos",
    technicalDifficulties:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongFetchingTeamFileTransferChart:
      "Algo salió mal al obtener los detalles del gráfico de transferencia de archivos de su equipo. Si continúa viendo este problema, comuníquese con el administrador del sistema.",
    somethingWentWrongFetchingTeamFileTransferChartTryLater:
      "Algo salió mal al obtener los detalles del gráfico de transferencia de archivos de su equipo. Por favor, inténtelo después de un tiempo.",

    // ListIndividualFileActions.vue
    retry: "Reintentar",
    time: "Hora",
    action: "Acción",
    source: "Fuente",
    folder: "Carpeta",
    fileName: "Nombre del Archivo",
    domain: "Dominio",
    fileExtension: "Extensión de Archivo",
    noFileOperationalActivitiesFound:
      "No se encontraron actividades operativas de archivos",
    noMatchingSearchResultsFound:
      "No se encontraron resultados de búsqueda coincidentes.",
    tryAgainByChangingFilters:
      "Inténtelo de nuevo cambiando los filtros o bórrelos para obtener todos los datos.",
    technicalDifficultiesWithErrorCode:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas. Por favor, inténtelo después de un tiempo - ",
    somethingWentWrongFetchingFileTransferDetails:
      "Algo salió mal al obtener los detalles de transferencia de archivos. Si continúa viendo este problema, comuníquese con el administrador del sistema - ",
    somethingWentWrongFetchingTeamTransferDetails:
      "Algo salió mal al obtener los detalles de transferencia de su equipo. Por favor, inténtelo después de un tiempo",

    // ListFileTransfers.vue
    employees: "Empleados",
    somethingWentWrongFetchingTeamFileTransferDetails:
      "Algo salió mal al obtener los detalles de transferencia de archivos de su equipo. Si continúa viendo este problema, comuníquese con el administrador del sistema - ",
    somethingWentWrongFetchingTeamFileTransferDetailsTryLater:
      "Algo salió mal al obtener los detalles de transferencia de archivos de su equipo. Por favor, inténtelo después de un tiempo.",
    searchPlaceholder: "Buscar",
  },
};
